import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import Panel from '@inspire/ui/general/Panel';

const KitPanel = ({ title, children, ...props }) => (
  <Box as={Panel} p={0} mb={5} {...props}>
    <Heading
      size="sm"
      textAlign="center"
      p={4}
      m={0}
      bgColor="yellow.400"
      borderBottom="1px solid #d8d8d8"
      fontWeight="bold"
      color="#333"
    >
      {title}
    </Heading>
    <Box px={6} py={2}>
      {children}
    </Box>
  </Box>
);

export default KitPanel;
